import React from 'react';

/*
 * THE CURSOR, AS PIXELS.
 *
 * Drawn as an actual bitmap — one <rect> per pixel of the classic X11 arrow —
 * rather than as a smooth vector path. A crisp modern cursor at this size just
 * looks like a large icon; the stair-stepped one reads instantly as "a pointer
 * about to click something", which is the whole job.
 *
 * It lived inside ConnectStage, where the click demonstration needed it. It is
 * now shared, because the same mark does a second job on the product artefacts:
 * it names WHICH element the surrounding claim is about. A directory of agent
 * cards or a pair of tabs says nothing on its own about where to look, and an
 * arrow drawn in the brand's own idiom answers that without a caption.
 *
 * '#' is the dark outline, '.' the light fill, ' ' transparent.
 */
const CURSOR = ['#           ', '##          ', '#.#         ', '#..#        ', '#...#       ', '#....#      ', '#.....#     ', '#......#    ', '#.......#   ', '#........#  ', '#.....####  ', '#..#..#     ', '#.# #..#    ', '##  #..#    ', '#    #..#   ', '     #..#   ', '      #..#  ', '      ####  '];
export function PixelCursor({
  className = '',
  /** Outline / fill. The default reads on cream and on a photograph alike. */
  outline = '#1A120C',
  fill = '#FAF8F4'
}: {
  className?: string;
  outline?: string;
  fill?: string;
}) {
  return <svg viewBox="0 0 12 18" aria-hidden="true" shapeRendering="crispEdges" className={className} data-id="element-848" data-mp="hlj8iek0k3k5">
      {CURSOR.map((row, y) => row.split('').map((ch, x) => ch === ' ' ? null : <rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} fill={ch === '#' ? outline : fill} data-id="element-849" data-mp="3l42p2jtbxkz4" />))}
    </svg>;
}